import { moveToFulfilled } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import { FeedLoadFulfilledAction, FeedLoadOlderThreadsFulfilledAction } from '../../domains/feedLoad/actions.types';
import { SuggestedUsersDismissFulfilledAction } from '../../domains/suggestedUserDismiss/actions.types';
import { User } from '../types';

import { FeedUserSuggestionCard, UserSuggestionCard, UserSuggestionCards } from './types';

export const initialState: UserSuggestionCards = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

export type UserSuggestionCardAction =
  | FeedLoadFulfilledAction
  | FeedLoadOlderThreadsFulfilledAction
  | SuggestedUsersDismissFulfilledAction;

const updateUserSuggestionCardsOnThreadsLoad = (
  state: UserSuggestionCards,
  newUserSuggestionCards: Record<FeedUserSuggestionCard['id'], FeedUserSuggestionCard> | undefined
) => {
  if (!newUserSuggestionCards) {
    return state;
  }

  const userSuggestionCards = Object.keys(newUserSuggestionCards).reduce(
    (current: Record<UserSuggestionCard['id'], UserSuggestionCard>, id: FeedUserSuggestionCard['id']) => ({
      ...current,
      [id]: { ...newUserSuggestionCards[id], dismissedSuggestedUserIds: [] },
    }),
    {}
  );

  return moveToFulfilled(state, userSuggestionCards);
};

const updateUserSuggestionCardsOnDismiss = (state: UserSuggestionCards, userId: User['id']) => {
  const userSuggestionCards = Object.keys(state.fulfilled.byId).reduce(
    (current: Record<UserSuggestionCard['id'], UserSuggestionCard>, id: UserSuggestionCard['id']) => {
      const currentState = state.fulfilled.byId[id];

      return {
        ...current,
        [id]: {
          ...currentState,
          suggestedUserIds: currentState.suggestedUserIds.filter((suggestedUserId) => suggestedUserId !== userId),
          dismissedSuggestedUserIds: [...currentState.dismissedSuggestedUserIds, userId],
        },
      };
    },
    {}
  );

  return moveToFulfilled(state, userSuggestionCards);
};

const reducer: Reducer<UserSuggestionCards, UserSuggestionCardAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'FEED.LOAD_FULFILLED':
      return updateUserSuggestionCardsOnThreadsLoad(state, action.payload.entities.userSuggestionCards);
    case 'FEED.LOAD_OLDER_THREADS_FULFILLED':
      return updateUserSuggestionCardsOnThreadsLoad(state, action.payload.entities.userSuggestionCards);
    case 'SUGGESTED_USERS.DISMISS_FULFILLED':
      return updateUserSuggestionCardsOnDismiss(state, action.payload.userId);
    default:
      return state;
  }
};

export default reducer;
